import { useEffect } from "react";

type JsonLdProps = {
  schema: Record<string, unknown> | Record<string, unknown>[];
  /** Unique id so multiple schemas on one page don't collide. */
  id?: string;
};

/**
 * Injects a <script type="application/ld+json"> block into document.head.
 * Renders nothing visible. Safe for React SPA and static pre-render.
 */
export function JsonLd({ schema, id = "jsonld-default" }: JsonLdProps) {
  useEffect(() => {
    const scriptId = `jsonld-${id}`;
    let script = document.getElementById(scriptId) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement("script");
      script.id = scriptId;
      script.type = "application/ld+json";
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(schema);

    return () => {
      document.getElementById(scriptId)?.remove();
    };
  }, [schema, id]);

  return null;
}
